import React from 'react';
import styled from 'react-emotion';
import ProductComponent from '../Layout/ProductComponent';
import theme from '@jetshop/ui/utils/theme';

const RelewareContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  &::after {
    content: ' ';
    display: block;
    flex: auto;
  }
  ${theme('below.sm')} {
    > div {
      width: 50%;
      > a {
        margin: 0.2rem;
        margin-bottom: 0.4rem;
        padding: 1rem;
      }
      span {
        font-size: 0.6875rem;
        line-height: normal;
      }
    }
  }
`;

const SubHeader = styled('h3')`
  display: block;
  font-size: 1.25rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
  margin-top: 2.5rem;
  text-transform: uppercase;
  ${theme('below.sm')} {
    font-size: 0.9375rem;
    margin-bottom: 0.5rem;
  }
`;

const Container = styled('section')`
  width: 100%;
`;

const Releware = ({ products, title, className }) => {
  if (products.length < 1) {
    return null;
  }

  return (
    <Container className={className}>
      <SubHeader>{title}:</SubHeader>
      <RelewareContainer>
        {products.map((product, key) => (
          <ProductComponent
            product={product}
            productsPerRow="4"
            key={product.articleNumber}
          />
        ))}
      </RelewareContainer>
    </Container>
  );
};

export default Releware;
